import { useContext, useEffect, useState } from "react";
import Skill from "./Skill";
import { Resume } from "./Resume";
import { AlertMessage } from "../../../../blocks/ui/AlertMessage";
import { Layout } from "./Layout";
import { DContext } from "../../../../../context/Datacontext";
import { useLocation, useNavigate } from "react-router-dom";

export const ProfessionalProfile = ({ candidate, fetchCandidateData, setCandidate, isResumeParsing }) => {
  const { currentUser, showAlert } = useContext(DContext)
  const [skillsList, setSkillsList] = useState([]);
  const [resume, setResume] = useState()
  const [skills, setSkills] = useState([]);
  const navigate = useNavigate()

  // fetch the query:;

  const location = useLocation()
  const queryFetch = new URLSearchParams(location.search)
  const reverse = queryFetch.get('inverse') === "true"
  const previous = location.state?.from || '/account'
  const active = location.state?.active || 'Overview'



  const handleResumeData = (resume) => {
    setResume(resume)
  }
  const handleAddSkillData = (skills) => {
    // console.log("Skills", skills)
    setSkillsList(skills);
  }

  useEffect(() => {
    fetchCandidateData()
  }, [])

  useEffect(() => {
    if (candidate) {
      setSkills(candidate.skills); 
      // console.log("candidate:", skills, candidate)
    }
  }, [candidate])

  const handleNext = () => {
    // console.log("candidate:", skillsList, candidate)
    if ((!skillsList || skills.length === 0)) {
      // console.log("candidate:", skills, candidate)
      showAlert("Please add at least one skill before continuing");
      return;
    }
    else if (!candidate.resumeLink) {
      showAlert("Kindly upload the resume!")
      return
    }
    if (reverse)
      navigate(previous, { state: { active } })
    else
      window.location.href = `/update-account/profilesummery?candidateId=${candidate?._id}`
  };
  // console.log("Is Resume", isResumeParsing)
  return (
    <Layout candidate={candidate}>
      <section className="mb-24">

        {/* Skill Input */}
        <div className="w-full">
          <Skill submitData={handleAddSkillData} candidate={candidate} />
        </div>

        {reverse || !isResumeParsing && < div className="w-full">
          <Resume submitData={handleResumeData} candidate={candidate} _id={candidate._id} applicantID={candidate.applicantID} resumeAvailable={candidate.resumeAvailable} resumeLink={candidate.resumeLink} applicantName={candidate.applicantName} experience={candidate.experience} setCandidate={setCandidate} />
        </div>}
        {/* Buttons */}
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 w-full mt-1">
          <button onClick={() => navigate(`/update-account/personalInformation?candidateId=${candidate?._id}`)}
            className="w-full sm:w-auto border border-primary-500 text-primary-500 px-4 py-2 rounded-xl font-medium  transition text-center">
            Previous
          </button>
          <button
            type="button"
            onClick={handleNext} // show collected skills
            className="w-full sm:w-auto bg-[#2C25C4] text-white px-4 py-2 rounded-xl font-semibold shadow-md hover:opacity-90 transition text-center"
          >
            {reverse ? 'Update' : 'Next'}
          </button>
        </div>
      </section>
    </Layout >
  );
};
